import { paths } from 'src/routes/paths';

import type { NavProps, NavItemBaseProps } from 'src/components/nav-section/types';

// Group existing entries only after role and module permissions have been applied.
// Unclassified entries stay visible so future modules cannot silently disappear.
export function groupNavigation(items: NavItemBaseProps[]): NavProps['data'] {
  const groups = [
    {
      subheader: 'Marketing',
      paths: [
        paths.dashboard.planning,
        paths.dashboard.campaign.root,
        paths.dashboard.communities.root,
        paths.dashboard.message.root,
        paths.dashboard.jornadas.root,
      ],
    },
    {
      subheader: 'Benefícios',
      paths: [
        paths.dashboard.giftback.root,
        paths.dashboard.loyalty.root,
        paths.dashboard.coupon.root,
      ],
    },
    {
      subheader: 'Operação',
      paths: [
        paths.dashboard.pdv.root,
        paths.dashboard.product.root,
        paths.dashboard.service.root,
        paths.dashboard.appointment.root,
        paths.totem,
      ],
    },
    {
      subheader: 'Gestão',
      paths: [paths.dashboard.user.root, paths.dashboard.config.root],
    },
  ];
  const groupedPaths = new Set(groups.flatMap((group) => group.paths));
  const shortcuts = [
    paths.dashboard.root,
    paths.dashboard.customer.root,
    paths.dashboard.purchase.root,
    paths.dashboard.analytics.customer,
  ];
  const directItems = items.filter((item) => !groupedPaths.has(item.path));

  return [
    {
      subheader: 'Zeki',
      items: [
        ...shortcuts.flatMap((path) => directItems.filter((item) => item.path === path)),
        ...directItems.filter((item) => !shortcuts.includes(item.path)),
      ],
    },
    ...groups
      .map((group) => ({
        subheader: group.subheader,
        collapsible: true,
        items: group.paths.flatMap((path) => items.filter((item) => item.path === path)),
      }))
      .filter((group) => group.items.length > 0),
  ];
}
